export default __webpack_public_path__ + "6b415ebf23583cd3f8013a4e1769de11.png";